// extracted by mini-css-extract-plugin
module.exports = {"bgStep":"styles_bgStep__W3hqm","iconUpStep":"styles_iconUpStep__1PeqL"};